module.exports = __webpack_public_path__ + "img/Tokyo.fec6a45d.png";